import MDTypography from "components/MDTypography";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";

import { useState, useEffect } from "react";

import { getReserve, putReserve } from "../../../api/reserves";
import { getDevice, putDevice } from "../../../api/devices";

import Icon from "@mui/material/Icon";
import { API_URL } from "config/apiUrl";
import { getOrder } from "../../../api/orders";

import { useDispatch, useSelector } from "react-redux";

import { setCurrentOrder } from "../../../redux/reducers/ordersReducer";

function FileInput({
  device,
  type = null,
  reserve = null,
  setReserves = null,
  pictureNumber = null,
  fileDescription = null,
}) {
  const [file, setFile] = useState(null);

  const dispatch = useDispatch();

  const currentOrder = useSelector((state) => state.orders.currentOrder);

  const updateReserve = async (reserve, reserveId) => {
    await putReserve(reserve, reserveId);
    const response = await getReserve(device.device_id, type);
    setReserves(response.data);
  };

  async function updateDeviceAPI(device, deviceId) {
    await putDevice(device, deviceId);
    const orderResponse = await getOrder(currentOrder.order_id);
    dispatch(setCurrentOrder(orderResponse.data));
    const deviceResponse = await getDevice(deviceId);
    return await deviceResponse.data;
  }

  useEffect(() => {
    if (file !== null && pictureNumber === "1") {
      const reserve = {
        filename1: file,
      };
      updateReserve(reserve, file.substring(file.lastIndexOf("e") + 1, file.lastIndexOf("-")));
    } else if (file !== null && pictureNumber === "2") {
      const reserve = {
        filename2: file,
      };
      updateReserve(reserve, file.substring(file.lastIndexOf("e") + 1, file.lastIndexOf("-")));
    } else if (file !== null && pictureNumber === "3") {
      const reserve = {
        filename3: file,
      };
      updateReserve(reserve, file.substring(file.lastIndexOf("e") + 1, file.lastIndexOf("-")));
    } else if (file !== null && fileDescription === "-déclaration-UE") {
      const deviceFile = {
        ue_declaration_filename: file,
      };
      updateDeviceAPI(deviceFile, device.device_id);
    } else if (file !== null && fileDescription === "-contrôle-interne") {
      const deviceFile = {
        internal_control_filename: file,
      };
      updateDeviceAPI(deviceFile, device.device_id);
    } else if (file !== null && fileDescription === "-cr-inspection-finale") {
      const deviceFile = {
        cr_inspection_filename: file,
      };
      updateDeviceAPI(deviceFile, device.device_id);
    } else if (file !== null && fileDescription === "-att-inspection-finale") {
      const deviceFile = {
        att_inspection_filename: file,
      };
      updateDeviceAPI(deviceFile, device.device_id);
    } else if (file !== null && fileDescription === "-levée-réserves") {
      const deviceFile = {
        reserves_filename: file,
      };
      updateDeviceAPI(deviceFile, device.device_id);
    } else if (file !== null && fileDescription === "-DOE") {
      const deviceFile = {
        doe_filename: file,
      };
      updateDeviceAPI(deviceFile, device.device_id);
    } else if (file !== null && fileDescription === "-PPSPS") {
      const deviceFile = {
        ppsps_filename: file,
      };
      updateDeviceAPI(deviceFile, device.device_id);
    } else if (file !== null && fileDescription === "-MAD") {
      const deviceFile = {
        mad_filename: file,
      };
      updateDeviceAPI(deviceFile, device.device_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file]);

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      const fileName = `${device.device_number}${fileDescription ? fileDescription : ""}${
        reserve ? "-reserve" + reserve.reserve_id : ""
      }${pictureNumber ? "-photo" + pictureNumber : ""}.${file.name.split(".").pop()}`;
      setFile(fileName);

      // Create a new FormData instance
      const formData = new FormData();

      // Append the file to the formData
      formData.append("file", file, fileName);

      // Send the formData with fetch
      fetch(`${API_URL}files`, {
        method: "POST",
        body: formData,
        headers: {
          "Device-Id": device.device_id,
          "Device-Number": device.device_number,
          filetype: `${fileDescription ? fileDescription : ""}${
            reserve ? "-reserve" + reserve.reserve_id : ""
          }${pictureNumber ? "-photo" + pictureNumber : ""}.`,
          "X-API-KEY": process.env.REACT_APP_NGT_API_KEY,
          Authorization: "Bearer " + localStorage.getItem("sessionToken"),
        },
      })
        .then((response) => {
          response.text();
          // Force a refresh of the image
          const img = new Image();
          img.src = `${API_URL}upload/${fileName}?api_key=${
            process.env.REACT_APP_NGT_API_KEY
          }&session_token=${localStorage.getItem("sessionToken")}`;
          img.onload = () => setFile(fileName); // Update the state only after the new image is loaded
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  return (
    <InputLabel htmlFor={`import${reserve ? reserve.reserve_id : fileDescription}-${device.device_id}-button`}>
      <Input
        id={`import${reserve ? reserve.reserve_id : fileDescription}-${device.device_id}-button`}
        inputProps={{
          accept: reserve ? "image/*" : fileDescription === "-levée-réserves" ? ".msg" : ".pdf",
        }}
        onChange={handleFileChange}
        sx={{ display: "none" }}
        type="file"
      />
      <MDTypography
        sx={{
          "&:hover": {
            textDecoration: "underline",
          },
          cursor: "pointer",
          display: "table-cell",
          verticalAlign: "middle",
        }}
        display="block"
        variant="body2"
        fontWeight="medium"
        underline="hover"
      >
        <Icon sx={{ verticalAlign: "middle" }}>upload</Icon>{" "}
        {pictureNumber ? "Ajouter une image" : "Ajouter un fichier"}
      </MDTypography>
    </InputLabel>
  );
}

export default FileInput;
